<template>
  <b-card title="افزودن کد تخفیف جدید">
    <b-form >
      <b-row>
        <b-col cols="6">


          <b-form-group
              label="عنوان"
          >
            <b-form-input
                id="v-category-1"
                placeholder="لطفا عنوان را وارد کنید"
                v-model="postData.title"
            />
          </b-form-group>

          <b-form-group
              label="دسته"
              label-for="mother-categories"
          >
            <b-form-select
                id="type"
                v-model="postData.categoryID"
                :options="categories"
            />

          </b-form-group>



          <b-form-group
              label="قیمت "
          >
            <b-form-input
                id="v-category-3"
                placeholder="قیمت را وارد کنید"
                v-model="postData.price"
                type="number"
                max="100"
            />
          </b-form-group>

          <b-form-group
              label="درصد تخفیف "
          >
            <b-form-input
                placeholder="درصد تخفیف را وارد کنید"
                v-model="postData.discountPercent"
                type="number"
                max="100"
            />
          </b-form-group>


          <b-form-group
              label="توضیح کوتاه "
          >
            <b-form-textarea
                id="textarea-rows"
                placeholder="توضیح کوتاه را وارد کنید"
                rows="4"
                v-model="postData.shortDescription"
            />
          </b-form-group>

          <b-form-group
              label="توضیح بلند "
          >
            <b-form-textarea
                id="textarea-rowss"
                placeholder="توضیح بلند  را وارد کنید"
                rows="8"
                v-model="postData.longDescription"
            />
          </b-form-group>


          <b-form-group
              label="انتخاب عکس "
          >
            <b-form-file
                v-model="photo"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".jpg, .png,.svg"
            />
          </b-form-group>


          <b-form-group
              label="اتخاب نوع کتاب"
              label-for="mother-categories"
          >
            <b-form-select
                id="type1"
                v-model="postData.type"
                :options="types"
            />

          </b-form-group>


          <b-form-group v-if="postData.type === 1"
              label=" (متنی) انتخاب فایل کتاب "
          >
            <b-form-file
                v-model="book"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".epub"

            />
          </b-form-group>

          <b-form-group v-else-if="postData.type === 2"
                        label=" (صوتی) انتخاب فایل کتاب "
          >
            <b-form-file
                v-model="bookVoice"
                placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
                drop-placeholder="Drop file here..."
                accept=".mp3"
            />
          </b-form-group>




        </b-col>

        <b-col cols="6" >
          <img src="../../../assets/images/books.png" >
        </b-col>


        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="addBook"
              variant="success"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BFormRadio,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import axios from "@/libs/axios";
import Swal from 'sweetalert2'
import {$themeConfig} from "@themeConfig";
import uploadService from "@/modules/services/uploadService";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import Image from "@/views/components/image/Image";
import subscriptionRepository from "@/modules/subscriptions/services/subscriptionRepository";
import discountRepository from "@/modules/discount/services/discountRepository";
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { BFormTextarea} from 'bootstrap-vue'
import libraryRepository from '@/modules/library/services/libraryRepository'
Vue.use(Croppa);
export default {
  name: "addCategories",
  created() {
    this.getCategories();
  },
  components: {
    Image,
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormTextarea,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BImg,
    BFormRadio,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    videoFormComponent,
    datePicker: VuePersianDatetimePicker
  },
  data(){
    return {
      photo:undefined,
      book:undefined,
      bookVoice:undefined,
      selectedType:undefined,
      selectedBookType:undefined,
      types :[
        {
          value:1,
          text : 'متنی '
        },
        {
          value:2,
          text : 'صوتی'
        }
      ],
      discountType : [
        {
          value:1,
          text : 'قیمتی'
        },
        {
          value:2,
          text : 'درصدی'
        }
      ],
      selectedCategory:undefined,
      categories:[],
      postData:{
        categoryID: undefined,
        title: undefined,
        epubId: undefined,
        shortDescription: undefined,
        longDescription: undefined,
        price: 0,
        discountPercent: 0,
        photo: undefined,
        mediaIDs: [
        ],
        type: 0
      }
    }
  },
  methods: {

    async getCategories() {
      const {data} = await categoryRepository.get({type: 3});
      if (data.isSuccess) {
        let cats = data.data.data.map(p => {
          return {
            value: p.id, text: p.title
          }
        });
        cats.forEach(p => {
          this.categories.push(p);
        })
      }
    },
  async  addBook(){


      if (this.postData.title  && this.postData.shortDescription && this.postData.longDescription){



        if (this.photo){
          this.postData.photo = await uploadService.upload(this.photo);
        }

        if (this.book && this.postData.type === 1){
          let loc = await uploadService.upload(this.book);
          let losc = loc.split('/');
          let id = losc[losc.length - 1].split('.');

          this.postData.epubId = id[0];
        }

        if (this.bookVoice && this.postData.type === 2){
          let loc = await uploadService.upload(this.bookVoice);
          let losc = loc.split('/');
          let id = losc[losc.length - 1].split('.');

          this.postData.mediaIDs.push(id[0])
        }


        const {data} = await libraryRepository.create(this.postData);
        if (data.isSuccess){
          await Swal.fire({
            confirmButtonText: 'ok',
            title : 'موفقیت',
            html : 'عملیات با موفقیت انجام شد',
            icon: 'success'
          } );
          await this.$router.replace('/library/list')
        }else {
          await Swal.fire('هشدار', data.message, 'warning');
        }
      }else {
        await  Swal.fire('خطا' , ' نیاز است که فیلد های اجباری را پر کنید' , 'error')

      }








    },

  }
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

</style>
